<template>
    <div class="error-task">
        <div class="error-task-wrap">
            <div class="question"
                 v-for="(data,qindex) in questions">
                <div v-if="showNum"
                     class="question_num">第{{data.number}}题</div>
                <!-- 小学 -->
                <div v-if='sid == 21'>
                    <div class="title"
                         v-if="Object.keys(data.subject).length">
                        <span v-if="data.subject.content"
                              v-html="data.subject.content"></span>
                        <img :src="data.subject.image.url||data.subject.image"
                             v-if="data.subject.image || data.subject.image.url" />
                    </div>
                    <div v-for="(ask,inx) in data.asks">
                        <!-- 选择题 -->
                        <div v-if="ask.display_type==1">
                            <choice :question='ask'
                                    :askLength='data.asks.length'
                                    :sid="sid"
                                    :type="1"></choice>
                        </div>
                        <!-- 填空 -->
                        <div v-if='ask.display_type == 2'>
                            <blanks :question='ask'
                                    :askLength='data.asks.length'></blanks>
                        </div>
                        <!-- 主观题 -->
                        <div v-if='ask.display_type == 3'>
                            <subjective :ask='data.asks'
                                        :index='inx'
                                        :question='ask'
                                        :askLength='data.asks.length'></subjective>
                        </div>
                        <!-- 连线题 -->
                        <div class="line"
                             v-if="ask.display_type==4">
                            <lines :ask='ask'
                                   :sheet="ask.right_answer"
                                   :onlyshow='false'
                                   :askLength='data.asks.length'></lines>
                        </div>
                    </div>
                </div>
                <!-- 初中 -->
                <div v-else>
                    <div class="question">
                        <div class="title"
                             v-if="data.content.content||data.content.image_url">
                            <span v-if="data.content.content"
                                  v-html="data.content.content"></span>
                            <img :src="data.content.image_url"
                                 v-if="data.content.image_url" />
                        </div>
                        <div v-for="(ask) in data.asks">
                            <div class="title_t border-bb">
                                <span v-if="data.asks.length>1"
                                      class="num">({{ask.number}})</span>
                                <span v-if="ask.content.content"
                                      class="title_text"
                                      v-html="ask.content.content"></span>
                                <img :src="ask.content.image_url"
                                     v-if="ask.content.image_url" />
                            </div>
                            <!-- 选择题 -->
                            <!-- <choice :question='ask' :askLength='data.asks.length'></choice> -->
                            <choice v-if='data.display == 1'
                                    :question='ask'
                                    :askLength='data.asks.length'
                                    :sid="sid"
                                    :type="1"></choice>
                        </div>
                    </div>
                </div>
                <template v-if="type=='task'">
                    <div class="content"
                         v-if="data.wrong_stu_names.length">
                        <div class="title">答错<span>{{data.wrong_stu_names.length}}</span>人,错误率{{data.wrong_rate}}%</div>
                        <div class="name">
                            <span v-for="name in data.wrong_stu_names">{{name}}</span>
                        </div>
                    </div>
                    <div class="content"
                         v-else>
                        <div class="title_no">没有人答错</div>
                    </div>
                </template>
                <template v-else-if="type=='knowledg'">
                    <div class="content"
                         v-if="data.wrong_stu_names.length">
                        <div class="title">答错<span>{{data.wrong_stu_names.length}}</span>人,错误率{{data.wrong_rate}}%</div>
                        <div class="name">
                            <span v-for="name in data.wrong_stu_names">{{name}}</span>
                        </div>
                    </div>
                    <div class="content"
                         v-else>
                        <div class="title_no">没有人答错</div>
                    </div>
                </template>
            </div>
        </div>
        <div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import noResouse from 'COMPONENTS/noResouse.vue';
import choice from './module/choice.vue'  //选择题
import blanks from './module/blanks.vue'  //填空题
import lines from './module/line.vue';     //连线题
import subjective from './module/subjective.vue';//主观题
export default {
    props: ['questions', 'sid', 'type', 'showNum'],
    data () {
        return {
            // wrong_names: [],
            loading: true,
            // questions:[],
            // type:0,
        }
    },
    methods: {

    },
    mounted () {

    },
    created () {
        // this.questions.push(this.task)
    },
    components: {
        // loadingS,
        noResouse,
        subjective,
        choice,
        blanks,
        lines
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.error-task {
    display: block;
    margin: 0 auto;
}
.question_num {
    font-weight: bold;
    margin-bottom: 14px / $ppr;
    font-size: 28px / $ppr;
}
.content {
    // border-top: 1px/$ppr solid #E8E8E8;
    padding-top: 10px / $ppr;
    .title {
        height: 82px / $ppr;
        line-height: 82px / $ppr;
        font-size: 28px / $ppr;
        padding: 0 24px / $ppr;
        // border-bottom: 1px/$ppr solid #E8E8E8;
        color: #222;
    }
    .name {
        padding: 0 24px / $ppr;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        // min-height: 200px/$ppr;
        span {
            width: 30%;
            font-size: 28px / $ppr;
            color: #333;
            margin: 12px / $ppr 0;
        }
    }
}

.nodata {
    color: #aaa;
    margin-top: 50px / $ppr;
    margin-bottom: 50px / $ppr;
    text-align: center;
    span {
        display: inline-block;
        color: #ccc;
        font-size: 110px / $ppr;
        margin-bottom: 36px / $ppr;
    }
}

.question {
    // margin-bottom: 24px/$ppr;
    // display: block;
    width: 600px / $ppr;
    padding: 36px / $ppr 30px / $ppr;
    margin: 30px / $ppr auto 0;
    background: #fff;
    border-radius: 16px / $ppr;
    .title {
        // padding: 24px/$ppr 24px/$ppr;
        padding: 24px / $ppr 0;
        display: block;
        span {
            display: inline-block;
        }
        img {
            display: inline-block;
        }
    }
    .ask {
        margin-bottom: 24px / $ppr;
        background-color: #fff;
    }
    .subtitle-wrap {
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    .subtitle {
        padding: 24px / $ppr 24px / $ppr;
    }
    .checked {
        color: #66cc22 !important;
        .spot {
            background-color: #66cc22 !important;
            border: 1px / $ppr solid #66cc22 !important;
            color: #fff;
        }
    }
}
.title_t {
    padding-bottom: 24px / $ppr;
}
.title_no {
    padding: 24px / $ppr 0 24px / $ppr;
    display: block;
}
</style>
